<div *ngIf="accountUnlocked">
  <div class="page-title">Unlock Account</div>
  <div class="page-sub-title">You have successfully unlocked your account</div>
</div>

<div class="col-lg-6 col-md-8 col-sm-10 col-lg-offset-3 col-md-offset-2 col-sm-offset-1 push-up-50">
  <div class="panel-auth">
    <img class="title-img" src="/images/veri-b.jpg" />

    <div class="col-md-10 col-sm-12 col-md-offset-1 col-sm-offset-0">
      <div class="" *ngIf="accountUnlocked">
        <h5 class="panel-title push-down-30">Account Unlocked</h5>

        <div class="push-up-20">
          <div class="profile-sec-wrap">
            <div class="panel-sub-title">You have successfully unlocked your MindBerry account. You can now continue to
              your account as usual.</div>
          </div>
        </div>

        <div class="col-sm-8 col-sm-offset-2 push-down-10 push-up-30">
          <a class="btn-main-proceed-alt" routerLink="/login">My Account</a>
        </div>

        <div class="clear"></div>
      </div>
    </div>

    <div class="clear"></div>
  </div>
  <div class="clear"></div>
</div>
